import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, BrainIcon, CreditCardIcon, FileTextIcon, LockIcon, PrinterIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/content';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: BookOpenIcon,
  label: '6 Tomos'
}, {
  icon: PrinterIcon,
  label: 'Listo para imprimir'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-128" data-mp="x8jmznet0shq">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-129" data-mp="s9q7xqjvctfg">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-blue-600 md:text-lg" data-id="element-130" data-mp="nb6mrsd3nlo5">
          <BrainIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="3j9u1d0dmvqmc" />
          MiMejorVersión™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.75rem] font-extrabold leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-7xl" data-id="element-132" data-mp="3o6amdlpjdov7">
          Su mente fuerte.
          <br data-id="element-133" data-mp="358hlsq2dxr0z" />
          <span className="text-blue-600" data-id="element-134" data-mp="3599f1u8ifco3">Lista. Desde hoy.</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.12,
        ease
      }} src={heroImage} alt="MegaPack Método Mente Viva: caja, los 6 tomos, láminas de ejercicios y tarjetas de conexión" className="mx-auto mt-10 w-full max-w-xl" width={1240} height={1240} data-id="element-135" data-mp="2qk3mgp46gkp6" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.18,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-136" data-mp="s2b8o0ipgn67">
          <p className="font-display text-2xl font-extrabold leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-137" data-mp="id050tel8app">
            El sistema N°1 para estimulación cognitiva en adultos mayores
          </p>
          <p className="mt-5 text-xl leading-relaxed text-ink md:text-2xl" data-id="element-138" data-mp="1b0drfxkntnvk">
            200 ejercicios + 3 bonos. Todo listo. Sin armarlo.
          </p>

          <ul className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-139" data-mp="112g5jgq9w364">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-800 ring-1 ring-blue-100" data-id="element-140" data-mp="x02zssbj059c">
                <Icon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-141" data-mp="3hqkbsklh5wuf" />
                {label}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-142" data-mp="21awca5mhyleu">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-143" data-mp="21a4ovi31ztzn">
              Quiero mi Método Mente Viva ahora
            </CtaButton>
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-144" data-mp="26869i7g4o1d8">
            <li className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="2g0c0peyk2erd">
              <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-146" data-mp="2g1wu3194vrnn" /> Garantía 7 días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="2p0h6xls0j73y">
              <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-148" data-mp="2p10i8jn5qx90" /> Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-149" data-mp="2tysfzuahhdl4">
              <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-150" data-mp="unj0jd9foulw" /> Mercado Pago
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}